export const INSTRUCTOR_CURRENT_BATCHES = "INSTRUCTOR_CURRENT_BATCHES"; 


export const INSTRUCTOR_VIEW_BATCH_DETAIL = "INSTRUCTOR_VIEW_BATCH_DETAIL"; 

export const INSTRUCTOR_RETRIEVE_CLASS= "INSTRUCTOR_RETRIEVE_CLASS"; 